import React from 'react';
import {isFromAccountingTeam, isFromTechTeam} from '../../auth/UserPermissions';
import PermissionsModal from '../PermissionsModal';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import TestRequestsTable from './components/TestRequestsTable';
import {getUserName} from '../../auth/MidwayJwtToken';
import {MY_TEST_ITEM_1, MY_TEST_ITEM_2, TestRequest} from './model/TestRequest';
import CreateNewTestRequestModal from './components/CreateNewTestRequestModal';
import {Redirect, useLocation} from 'react-router-dom';
import * as paths from '../../util/paths';
import {BreadcrumbGroup} from '@amzn/awsui-components-react';


export default function ViewAllRequests(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [showCreateNewItemModal, setShowCreateNewItemModal] = React.useState(false);
    const [selectedTestRequest, setSelectedTestRequest] = React.useState({} as TestRequest);
    const [redirectToDetailsPage, setRedirectToDetailsPage] = React.useState(false);

    const location = useLocation();
    const user = getUserName();


    const createTestRequestButtonClick = (event: CustomEvent) => {
        event.preventDefault();
        setShowCreateNewItemModal(true);
    }

    const viewTestRequestDetailsButtonClick = (event: CustomEvent) => {
        event.preventDefault();

        if (selectedTestRequest) {
            setRedirectToDetailsPage(true);
        }
    }

    const getRequestDetailsPath = () => {
        const requestId: string = selectedTestRequest.identifier;
        const pathName: string = paths.MANUAL_TESTING_VIEW_CURRENT_REQUEST
            .replace(':request_id', requestId);

        return pathName;
    }


    const testItems = () => {
        let returnVal: TestRequest[] = [];

        if (paths.MANUAL_TESTING_USER_REQUESTS === location.pathname) {
            // TODO - query DDB to get the testing created by this user
            console.log("logging as replacement for calling DDB for user: " + user);
            returnVal = [MY_TEST_ITEM_1, MY_TEST_ITEM_2];
        }
        else if (paths.MANUAL_TESTING_ALL_REQUESTS === location.pathname) {
            // TODO - scan DDB to get the testing created for all users
            console.log("logging as replacement for scanning DDB");
            returnVal = [MY_TEST_ITEM_1, MY_TEST_ITEM_2];
        }

        return returnVal;
    }

    return (
        <Box>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <BreadcrumbGroup
                    items={[
                        { text: "Testing Home", href: paths.getRelativePath(paths.MANUAL_TESTING) },
                        { text: "Requests", href: paths.getRelativePath(paths.MANUAL_TESTING_USER_REQUESTS) },
                    ]}
                    ariaLabel="Breadcrumbs"
                />
                <TestRequestsTable
                    testItems={testItems()}
                    createNewTestItemButtonClick={createTestRequestButtonClick}
                    viewDetailsButtonClick={viewTestRequestDetailsButtonClick}
                    setSelectedItem={setSelectedTestRequest}
                />
                <CreateNewTestRequestModal
                    isVisible={showCreateNewItemModal}
                    setVisible={setShowCreateNewItemModal}
                    operation={'create'}
                />
                {redirectToDetailsPage &&
                    <Redirect to={{
                        pathname: getRequestDetailsPath(),
                        state: { request: selectedTestRequest}
                    }} />}
            </SpaceBetween>}
        </Box>
    );
}